import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastProvider } from "./common/toast/ToastContext";
import { AuthProvider } from "./user_module/context/AuthContext";

// ================= USER MODULE =================
import Homepage from './user_module/components/Homepage';
import UserForm from './user_module/components/UserForm';
import TimeTable from './user_module/components/time_table/TimeTable';
import RegisterPage from './user_module/components/login_and_registration/RegisterPage';
import LoginPage from './user_module/components/login_and_registration/LoginPage';
import FooterLinks from './user_module/components/FooterLinks';
import CombinedSection from './user_module/components/CombinedSection';
import PrivacyPolicy from './user_module/components/PrivacyPolicy';
import TermsAndConditions from './user_module/components/TermsAndConditions';
import RefundPolicy from './user_module/components/RefundPolicy';
import ShippingPolicy from './user_module/components/ShippingPolicy';
import ContactUs from './user_module/components/ContactUs';
import ProfilePage from './user_module/components/profile/ProfilePage';
import ClientPlansPage from './user_module/components/subscription_plans/ClientPlansPage';
import PrivateRoute from './user_module/components/PrivateRoute';
import TransactionHistoryPage from './user_module/components/subscription_plans/TransactionHistoryPage';
import MyActivePlanPage from './user_module/components/userSubscriptionPlan/MyActivePlanPage'
import Faqs from "./user_module/components/faq/Faqs";
import HowItWorksPage from './user_module/components/HowItWorksPage';
import GettingStarted from "./user_module/components/GettingStarted";
import ForgotPasswordPage from "./user_module/components/login_and_registration/ForgotPasswordPage";
import ResetPasswordPage from "./user_module/components/login_and_registration/ResetPasswordPage";
import Support from "./user_module/components/support/Support";
import TicketHistory from "./user_module/components/support/TicketHistory";
import TicketDetail from "./user_module/components/support/TicketDetail";
import ReviewsPage from "./user_module/components/review/ReviewsPage";
import CheckoutPage from "./user_module/components/subscription_plans/CheckoutPage";
import PaymentResultPage from "./user_module/components/subscription_plans/PaymentResultPage";
import Account from "./user_module/components/profile/Account";
import AnnouncementBar from "./user_module/announcement/AnnouncementBar";
import ReferralPage from "./user_module/components/referral/ReferralPage";
import StudyHub from "./user_module/components/study/StudyHub";
import VocabularyPage from "./user_module/components/study/vocabulary/VocabularyPage";
import VocabularyDetailPage from "./user_module/components/study/vocabulary/VocabularyDetailPage";
import VocabularyGroupsPage from "./user_module/components/study/vocabulary/VocabularyGroupsPage";
import VocabularyGroupDetailPage from "./user_module/components/study/vocabulary/VocabularyGroupDetailPage";
import WordOfDayPage from "./user_module/components/study/vocabulary/WordOfDayPage";
import TongueTwisterPage from "./user_module/components/study/tongue-twister/TongueTwisterPage";
import TongueTwisterDetailPage from "./user_module/components/study/tongue-twister/TongueTwisterDetailPage";
import QuickBoostPage from "./user_module/components/study/quick-boost/QuickBoostPage";
import QuickBoostDetailPage from "./user_module/components/study/quick-boost/QuickBoostDetailPage";
import GrammarTopicListPage from "./user_module/components/study/grammar/GrammarTopicListPage";
import GrammarTopicDetailPage from "./user_module/components/study/grammar/GrammarTopicDetailPage";
import GrammarSubTopicDetailPage from "./user_module/components/study/grammar/GrammarSubTopicDetailPage";
import DailySentenceListPage from "./user_module/components/study/daily-sentences/DailySentenceListPage";
import DailySentenceCategoryPage from "./user_module/components/study/daily-sentences/DailySentenceCategoryPage";
import DailySentenceDetailPage from "./user_module/components/study/daily-sentences/DailySentenceDetailPage";
import OfficialSentenceListPage from "./user_module/components/study/official-sentences/OfficialSentenceListPage";
import OfficialSentenceCategoryPage from "./user_module/components/study/official-sentences/OfficialSentenceCategoryPage";
import OfficialSentenceDetailPage from "./user_module/components/study/official-sentences/OfficialSentenceDetailPage";
import SimilarWordsListPage from "./user_module/components/study/similar-words/SimilarWordsListPage";
import SimilarWordsDetailPage from "./user_module/components/study/similar-words/SimilarWordsDetailPage";
import IpaSymbolListPage from "./user_module/components/study/ipa/IpaSymbolListPage";
import IpaSymbolDetailPage from "./user_module/components/study/ipa/IpaSymbolDetailPage";
import IpaLessonListPage from "./user_module/components/study/ipa/IpaLessonListPage";
import IpaLessonDetailPage from "./user_module/components/study/ipa/IpaLessonDetailPage";
import PhraseListPage from "./user_module/components/study/phrases/PhraseListPage";
import PhraseDetailPage from "./user_module/components/study/phrases/PhraseDetailPage";
import HomonymListPage from "./user_module/components/study/homonym/HomonymListPage";
import HomonymDetailPage from "./user_module/components/study/homonym/HomonymDetailPage";
import PracticeSentencePage from "./user_module/components/study/practice-sentences/PracticeSentencePage";
import ReadingListPage from "./user_module/components/study/reading/ReadingListPage";
import ReadingDetailPage from "./user_module/components/study/reading/ReadingDetailPage";
import EmailInfoPage from "./user_module/components/EmailInfoPage";
import SocialMediaPage from "./user_module/components/social_media/SocialMediaPage";

// ================= ADMIN MODULE =================
import AdminLoginPage from "./auth/AdminLoginPage";
import AdminRoutes from "./admin_module/routes/AdminRoutes";
import EventListPage from "./user_module/components/event/EventListPage";
import BookingPage from "./user_module/components/event/BookingPage";
import MyBookingsPage from "./user_module/components/event/MyBookingsPage";

function App() {
 return (
 <ToastProvider>
 <AuthProvider>
 <Router>
 <Routes>

 {/* ================= PUBLIC USER ROUTES ================= */}
 <Route path="/" element={<Homepage />} />
 <Route path="/register" element={<RegisterPage />} />
 <Route path="/login" element={<LoginPage />} />
 <Route path="/users" element={<UserForm />} />
 <Route path="/timetable" element={<TimeTable />} />
 <Route path="/footerLinks" element={<FooterLinks />} />
 <Route path="/combinedSection" element={<CombinedSection />} />
 <Route path="/privacy-policy" element={<PrivacyPolicy />} />
 <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
 <Route path="/cancellation-refund" element={<RefundPolicy />} />
 <Route path="/shipping-policy" element={<ShippingPolicy />} />
 <Route path="/contact" element={<ContactUs />} />
 <Route path="/plans" element={<ClientPlansPage />} />
 <Route path="/my-active-plan" element={<MyActivePlanPage />} />
 <Route path="/transaction-history" element={<TransactionHistoryPage />} />
 <Route path="/faqs" element={<Faqs />} />
 <Route path="/how-it-works" element={<HowItWorksPage />} />
 <Route path="/getting-started" element={<GettingStarted />} />
 <Route path="/support" element={<Support />} />
 <Route path="/forgot-password" element={<ForgotPasswordPage />} />
 <Route path="/reset-password" element={<ResetPasswordPage />} />
 <Route path="/support/tickets" element={<TicketHistory />} />
 <Route path="/support/tickets/:ticketId" element={<TicketDetail />} />
 <Route path="/reviews" element={<ReviewsPage />} />
 <Route path="/checkout/:planId" element={<CheckoutPage />} />
 <Route path="/payment-result" element={<PaymentResultPage />} />
 <Route path="/account" element={<Account />} />
 <Route path="/announcementBar" element={<AnnouncementBar />} />
 <Route path="/referral" element={<ReferralPage />} />
 <Route path="/study" element={<StudyHub />} />
 <Route path="/study/vocabulary" element={<VocabularyPage />} />
 <Route path="/study/vocabulary/word-of-day" element={<WordOfDayPage />} />
 <Route path="/study/vocabulary/groups" element={<VocabularyGroupsPage />} />
 <Route path="/study/vocabulary/groups/:id" element={<VocabularyGroupDetailPage />} />
 <Route path="/study/vocabulary/:id" element={<VocabularyDetailPage />} />
 <Route path="/study/tongue-twisters" element={<TongueTwisterPage />} />
 <Route path="/study/tongue-twisters/:id" element={<TongueTwisterDetailPage />} />
 <Route path="/study/quick-boost" element={<QuickBoostPage />} />
 <Route path="/study/quick-boost/:id" element={<QuickBoostDetailPage />} />
 <Route path="/study/grammar" element={<GrammarTopicListPage />} />
 <Route path="/study/grammar/:id" element={<GrammarTopicDetailPage />} />
 <Route path="/study/grammar/sub-topic/:subTopicId" element={<GrammarSubTopicDetailPage />} />
 <Route path="/study/daily-sentences" element={<DailySentenceListPage />} />
 <Route path="/study/daily-sentences/category/:categoryId" element={<DailySentenceCategoryPage />} />
 <Route path="/study/daily-sentences/:id" element={<DailySentenceDetailPage />} />
 <Route path="/study/official-sentences" element={<OfficialSentenceListPage />} />
 <Route path="/study/official-sentences/category/:categoryId" element={<OfficialSentenceCategoryPage />} />
 <Route path="/study/official-sentences/:id" element={<OfficialSentenceDetailPage />} />
 <Route path="/study/similar-words" element={<SimilarWordsListPage />} />
 <Route path="/study/similar-words/:groupId" element={<SimilarWordsDetailPage />} />
 <Route path="/study/ipa/symbols" element={<IpaSymbolListPage />} />
 <Route path="/study/ipa/symbols/:id" element={<IpaSymbolDetailPage />} />
 <Route path="/study/ipa/lessons" element={<IpaLessonListPage />} />
 <Route path="/study/ipa/lessons/:id" element={<IpaLessonDetailPage />} />
 <Route path="/study/phrases" element={<PhraseListPage />} />
 <Route path="/study/phrases/:id" element={<PhraseDetailPage />} />
 <Route path="/study/homonyms" element={<HomonymListPage />} />
 <Route path="/study/homonyms/:id" element={<HomonymDetailPage />} />
 <Route path="/study/practice-sentences" element={<PracticeSentencePage />} />
        <Route path="/study/reading" element={<ReadingListPage />} />
        <Route path="/study/reading/:id" element={<ReadingDetailPage />} />
 <Route path="/events" element={<EventListPage />} />
 <Route path="/booking/:eventId" element={<BookingPage />} />
 <Route path="/my-bookings" element={<MyBookingsPage />} />
 <Route path="/email-info" element={<EmailInfoPage />} />
 <Route path="/social-media" element={<SocialMediaPage />} />
 

 {/* ================= PROTECTED USER ROUTES ================= */}
 <Route
 path="/profile"
 element={
 <PrivateRoute>
 <ProfilePage />
 </PrivateRoute>
 }
 />

 {/* ================= ADMIN ROUTES ================= */}
 <Route path="/admin/login" element={<AdminLoginPage />} />
 <Route path="/admin/*" element={<AdminRoutes />} />

 </Routes>
 </Router>
 </AuthProvider>
 </ToastProvider>
 );
}

export default App;
